const FieldLabel = ({ label, required }) => (
  <span>
    {label}
    {required && <span style={{ color: "red", marginLeft: 2 }}>*</span>}
  </span>
);

export default FieldLabel;
